export default __webpack_public_path__ + "static/media/lightbox.d8717fd8.png";